import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ChangeDetectionStrategy, Component, Inject, TemplateRef} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogConfig, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {kombiner} from "felles-ng2/støttefunksjoner/objekter";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";
import {TranslateModule} from "@ngx-translate/core";
import {litenIkkeTomStreng} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {LitenIkkeTomStreng} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {NgTemplateOutlet} from "@angular/common";

const debug = initDebugger('SlettMedÅrsakDialogKomponent');

export type SlettMedÅrsakDialogRespons = LitenIkkeTomStreng | null;

/** Viser bekreftelsesdialog, brukes i via {@link Bekreftelsesdialog}. */
@Component({
    selector: 'slett-med-aarsak-dialog',
    templateUrl: 'slett-med-årsak-dialog.html',
    styleUrl: 'slett-med-årsak-dialog.scss',
    imports: [
        MatDialogActions,
        MatDialogTitle,
        MatDialogContent,
        MatButton,
        MatError,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
        TranslateModule,
        NgTemplateOutlet,
        StandardValideringsfeilPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlettMedÅrsakDialogKomponent {

    static vis(dialog: MatDialog, parametre: DialogParametre): MatDialogRef<SlettMedÅrsakDialogKomponent, SlettMedÅrsakDialogRespons> {
        return dialog.open(SlettMedÅrsakDialogKomponent, matDialogKonfig(parametre));
    }

    skjema = new FormGroup({aarsak: new FormControl('', litenIkkeTomStreng)});
    parametre: DialogParametre;

    constructor(private oversettelser: Oversettelser, @Inject(MAT_DIALOG_DATA) parametre: DialogParametre, public dialogRef: MatDialogRef<SlettMedÅrsakDialogKomponent, SlettMedÅrsakDialogRespons>) {
        this.parametre = kombiner(this.standardVerdier(), parametre);
    }

    //private hjelpemetoder

    private standardVerdier(): Partial<DialogParametre> {
        return {
            okKnapp: this.oversettelser.oversett(i18n('Slett')),
            avbrytKnapp: this.oversettelser.oversett(i18n('Avbryt'))
        };
    }

    slett() {
        this.dialogRef.close(this.skjema.value.aarsak);
    }

    avbryt() {
        this.dialogRef.close(null);
    }
}

function matDialogKonfig(parametre: DialogParametre): MatDialogConfig<DialogParametre> {
    return {
        data: parametre,
        disableClose: true,
        panelClass: `slettMedÅrsakDialogPanel`,
        ariaLabelledBy: 'slett-med-aarsak-dialog-tittel',
        minHeight: 200,
        width: '400px'
    };
}

export interface DialogParametre {
    tittel: string;
    innhold?: string;
    htmlInnhold?: TemplateRef<any>;
    htmlInnholdContext?: any;
    okKnapp?: string;
    avbrytKnapp?: string;
}
